import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useInternationalization } from "@progress/kendo-react-intl";
import DateInput from '../../forms/DateInput';
import { dateToFormattedString, getFormat } from "../../utils/convert";
import { fieldFormat } from "../../utils/helper";
import PropTypes from "prop-types";

/**
 * Edit datetime cell component
 * @module
 * @param {func} onChange - Function invoked on change
 * @param {string} dataItem - Data item
 * @param {string} field - Field
 * @param {string} className - TD Class name
 * @param {number} colSpan - Number of columns which cell expands to
 * @param {object} style - Style
 * @param {number} columnIndex - Column index
 * @param {number} level - Level
 * @param {func} render - Render function
 */
export const editDateTimeCell = ({ getColumns, isValueChanged }) => {
  const EditDateTimeCell = (props) => {
    let timeout = null;

    const intl = useInternationalization();
    const { onChange, dataItem, field, tdProps, format, isInEdit } = props;
    const [value, setValue] = useState(_.get(dataItem, field.split(".")));

    // const handleChange = (e) => {
    //   setValue(e.target.value);

    //   if (timeout) {
    //     clearTimeout(timeout);
    //     timeout = null;
    //   }

    //   timeout = setTimeout(() => {
    //     onChange({
    //       dataItem: dataItem,
    //       field: field,
    //       syntheticEvent: e.syntheticEvent,
    //       value: e.target.value,
    //     });

    //     timeout = null;
    //   }, 1000);
    // };

    const handleInputChange = (name, value) => {
      setValue(value);

      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      timeout = setTimeout(() => {
        onChange({
          dataItem: dataItem,
          field: field,
          syntheticEvent: new Event("change"),
          value: value,
        });

        timeout = null;
      }, 1000);
    };

    useEffect(() => {
      setValue(_.get(dataItem, field.split(".")));
    }, [dataItem, field]);

    const buildInput = (column, dataValue, format) => {
      return <DateInput
        type={column.filter.replace("input", "")}
        onChange={handleInputChange}
        value={dataValue}
        format={format}
        name={column.field}
        todayHidden={true}
        validationHidden={true}
      />
    };

    const column = getColumns().find((item) => item.field === field);
    const newFormat = format ?
      getFormat(fieldFormat(format), column.filter.replace('input', '')) :
      column.filter === "time" ? "HH:mm" : column.filter === "date" ? "dd.MM.yyyy" : "dd.MM.yyyy H:m";
    const dataValue = value;

    return <td
      {...tdProps}
      className={`${tdProps.className} ${isValueChanged && isValueChanged(dataItem, field) ? "k-state-changed" : ""}`}
      tabIndex={0}
    >
      {isInEdit ? buildInput(column, dataValue, newFormat) : dateToFormattedString(dataValue, column.filter.replace('input', ''), newFormat, intl)}
    </td>
  };

  EditDateTimeCell.propTypes = {
    onChange: PropTypes.func,
    dataItem: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    field: PropTypes.string,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    style: PropTypes.object,
    columnIndex: PropTypes.number,
    level: PropTypes.number,
    render: PropTypes.func,
  };

  return EditDateTimeCell;
};
